// extracted by mini-css-extract-plugin
module.exports = {"block":"_6830","title":"_14915","content":"_14651","more":"_6345","arrow":"_17891"};